export default function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-[#e5e2d9] pb-6 mb-8 animate-fade-up"
      data-testid={testid}
    >
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#8a8476] mb-3">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1c1917] leading-tight sm:leading-none">
          {title}
        </h1>
        {description && (
          <p className="mt-3 text-sm sm:text-base text-[#57534e] leading-relaxed">{description}</p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:gap-3">{actions}</div>}
    </div>
  );
}
